/**
 * Created by Marcus Zhao on 11/28/2020
 * Description:
 * ---------maintenance history-------------
 * Update by Holly Li on 09/29/2022 - Handle international phone number formating.
 */

import { findPhoneNumbersInText, parsePhoneNumber } from 'libphonenumber-js';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ReplaySubject, Subscription } from 'rxjs';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import * as _lodash from 'lodash';
import { UUID } from 'angular2-uuid';
import { Store } from '@ngrx/store';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';
import { AppState } from '../../../../redux';
import { ChangeContactTemplateValueSet } from '@tamalelibs/redux/contact.actions';
import { ContactTemplateType, ContactAction, EmailAction, ControlId } from '../../../contact-dialog-new/contact-dialog.model';
import { businessConstants, validReg } from '../../../../constants/business.constants';
import { ContactViewModel } from '@tamalelibs/components/contact.view-model';

@Component({
    selector: 'tam-contact-combine-dropdown-input',
    templateUrl: './contact-combine-dropdown-input.component.html',
    styleUrls: ['./contact-combine-dropdown-input.component.scss'],
    standalone: false
})
export class ContactCombineDropdownInputComponent implements OnInit, OnDestroy {
    @Input() childConfig: any;
    config: any;
    suggestionItems: Array<any> = []; // suggestion items based on search, sub set of dataItems
    selectedItem: any; // selected items, sub set of dataItems
    isFirstInit = true;
    inputValue = '';
    isHidePrimary = true;
    primaryDetail = '';
    clickable: boolean;
    isPrimary = false;
    hintContent = '';
    isPhone: boolean;
    private _destroySubscriptions: Array<Subscription> = [];
    private _contactEmailGroupIds;
    private _isvalidCountryCode: boolean;

    constructor(
        private _store: Store<AppState>,
        private _contactTemplateService: ContactTemplateService,
        private _contactViewModel: ContactViewModel
    ) { }

    ngOnInit() {
        this._initData();
        if (this.config.action === ContactTemplateType.NewContact && !this.config.isSignature) {
            this._initDefaultValue();
        } else if (this.config.action === ContactTemplateType.EditContact || this.config.isSignature) {
            this._initDefaultValue();
            this._initEditValue();
        }
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    /**
     * add dynamic control
     *
     * @param {*} event
     * @memberof ContactCombineDropdownInputComponent
     */
    clickAddCtrol(event) {
        this.updateContorlLayout(true);
    }

    /**
     * remove dynamic control
     *
     * @param {*} event
     * @memberof ContactCombineDropdownInputComponent
     */
    clickRemoveLayout(event) {
        this.updateContorlLayout(false);
        this.selectedItem = null;
        this.inputValue = '';
        if (this.config.controlID.indexOf(ControlId.Email) > -1) {
            this.processPrimaryEmail();
        }
    }

    updateContorlLayout(isAdd: boolean = true) {
        const newCtrlJson = _lodash.cloneDeep(this.childConfig);
        if (isAdd) {
            newCtrlJson.config.controlID = newCtrlJson.config.type + UUID.UUID();
            const index = this.childConfig.dataSource.findIndex(item => item.name === newCtrlJson.config.defaultValue);
            if (index < this.childConfig.dataSource.length - 1) {
                newCtrlJson.config.defaultValue = this.childConfig.dataSource[index + 1].name;
            } else {
                newCtrlJson.config.defaultValue = this.childConfig.dataSource[0].name;
            }
            newCtrlJson.config.editValue = null;
            newCtrlJson.config.isCanDelete = true;
            newCtrlJson.config.isLabelHidden = true;
            // Due to set required for email only use to primary email .so email need follow orignal check status
            if (newCtrlJson.config.controlID.indexOf(ControlId.Email) === -1) {
                newCtrlJson.config.isRequired = false;
            }
        }
        if (this.config.controlID.indexOf(ControlId.Email) > -1) {
            if (isAdd) {
                this._contactViewModel.increment(newCtrlJson.config.controlID, this.config.prefixId);
            }
        }
        this._contactTemplateService.actionSubject$.next({
            type: isAdd ? ContactAction.AddControl : ContactAction.RemoveControl,
            payload: {
                ctrlType: this.config.controlType,
                ctrl: newCtrlJson,
                secSName: this.config.secSName,
                controlID: this.config.controlID,
            }
        });
    }

    mouseEnterLabel() {
        if (this.config.controlID.indexOf(ControlId.Email) > -1) {
            if (!this.isPrimary) {
                this.isHidePrimary = false;
            }
        }
    }

    mouseLeaveLabel() {
        if (this.config.controlID.indexOf(ControlId.Email) > -1) {
            if (!this.isPrimary) {
                this.isHidePrimary = true;
            }
        }
    }

    onBlur() {
        // Bowen  add feature
        // format the phone number when it has country code or has 10-digits.
        if (this.isPhone) {
            if (this._isvalidCountryCode) {
                this.inputValue = parsePhoneNumber(this.inputValue).formatInternational().split(' ').join('-');
            } else {
                const originalValue = _lodash.cloneDeep(this.inputValue);
                this.inputValue = this.inputValue.trim().split('-').join('');
                if (/^([0-9]{10})$/.test(this.inputValue)) {
                    this.inputValue = this.inputValue.trim().substring(0, 3) + '-' + this.inputValue.trim().substring(3, 6) + '-' + this.inputValue.trim().substring(6, 10);
                } else {
                    this.inputValue = originalValue;
                }
            }
        }
        if (this.config.controlID.indexOf(ControlId.Email) > -1) {
            this._contactTemplateService.actionSubject$.next({
                type: EmailAction.ChangeEmailValue,
                payload: {
                    emailValue: this.inputValue,
                    emailControlID: this.config.controlID,
                    prefix: this.config.prefixId
                }
            });
        }
    }

    clickSetPrimaryEmail() {
        if (!this.isPrimary) {
            this.isPrimary = true;
            this._contactTemplateService.actionSubject$.next({
                type: EmailAction.SetPrimary,
                payload: {
                    isPrimary: true,
                    id: this.childConfig.config.controlID
                }
            });
            this.changeValueSet(true);
        }
    }

    /*
     * value for Dropdown
     * @param {*} tappedItem
     * @memberof ContactCombineDropdownInputComponent
     */
    valueChange(tappedItem) {
        this._contactTemplateService.changeValueStatus = true;
        this.changeValueSet(true);
    }

    /**
     *
     * @param {*} value
     * @memberof ContactCombineDropdownInputComponent
     */
    textChange(value) {
        if (this.isPhone) {
            // To verify phone number.Only the phone number with country code can be found.
            this._isvalidCountryCode = findPhoneNumbersInText(value.split('-').join('')).length === 1;
        }
        this.hintContent = '';
        this.inputValue = value;
        this._contactTemplateService.changeValueStatus = true;
        this.changeValueSet(true);
    }

    /**
     * init data source
     * @private
     * @memberof ContactCombineDropdownInputComponent
     */
    private _initData() {
        this.isPhone = this.childConfig.config.controlID.indexOf(ControlId.Phone) > -1;
        this.config = this.childConfig.config;
        this._addTid();
        this.selectedItem = this.config.defaultValue;
        this.suggestionItems = this.childConfig.dataSource.map(item => item.name);
        this._destroySubscriptions.push(
            this._contactTemplateService.actionSubject$.subscribe(action => {
                if (action.type === EmailAction.SetPrimary && this.config.controlID.indexOf(ControlId.Email) > -1) {
                    if (action.payload.id !== this.config.controlID) {
                        this.isPrimary = false;
                        this.hintContent = '';
                    } else {
                        this.isPrimary = true;
                        this.isHidePrimary = false;
                    }
                    this.changeValueSet();
                }
            }),
            this._contactTemplateService.validInputSubject$.subscribe((res) => {
                if (this.config.prefixId === res.prefixId) {
                    if (this.config.isRequired && !this.inputValue &&
                        (this.config.controlID.indexOf(ControlId.Email) === -1 || (this.config.controlID.indexOf(ControlId.Email) > -1 && this.isPrimary))) {
                        this.hintContent = businessConstants.tip;
                    } else if (!res.allPhone && this.config.controlID.indexOf('Phone') !== -1 && !((validReg.countryFullReg.test(this.inputValue.split('-').join(''))) || (findPhoneNumbersInText(this.inputValue.split('-').join(''))).length)) {
                        this.hintContent = 'Invalid Phone Number';
                    } else if (!res.allEmail && this.config.controlID.indexOf('Emails') !== -1 && !validReg.emailReg.test(this.inputValue)) {
                        this.hintContent = 'Invalid Email Address';
                    }
                }
            }),
            this._contactViewModel.getContactEamilCount(this.config.prefixId).subscribe(res => this._contactEmailGroupIds = res),
        );
    }

    private _addTid() {
        if (this.config.type === ControlId.Internet) {
            this.config['typeTid'] = 'InternetInfo_Type_type';
            this.config['valueTid'] = 'InternetInfo_Value';
        } else {
            this.config['typeTid'] = this.config.controlName + '_type';
            this.config['valueTid'] = this.config.controlName + '_Value';
        }
    }

    /**
     * init create value
     * @private
     * @memberof ContactCombineDropdownInputComponent
     */
    private _initDefaultValue() {
        this.selectedItem = this.config.defaultValue;
        if (this.config.controlID === ControlId.Email) {
            this.isPrimary = true;
            this.isHidePrimary = false;
            this.inputValue = this.config.defaultValueEmail;
        }
        this.changeValueSet();
    }

    /**
     *init edit value
     *
     * @private
     * @memberof ContactCombineDropdownInputComponent
     */
    private _initEditValue() {
        if (this.config.editValue) {
            this.selectedItem = this.config.editValue.name;
            const id = this.config.controlID;
            if (id.indexOf(ControlId.Phone) > -1) {
                this.inputValue = this.config.editValue.phone;
                if (!((validReg.countryFullReg.test(this.inputValue.split('-').join(''))) || (findPhoneNumbersInText(this.inputValue.split('-').join(''))).length)) {
                    this.hintContent = 'Invalid Phone Number';
                }
            } else if (id.indexOf(ControlId.Email) > -1) {
                this.inputValue = this.config.editValue.address;
                this.isPrimary = this.config.editValue.primaryEmail;
                if (this.isPrimary) {
                    this.isHidePrimary = false;
                }
                if (!validReg.emailReg.test(this.inputValue)) {
                    this.hintContent = 'Invalid Email Address';
                }
            } else if (id.indexOf(ControlId.Internet) > -1) {
                this.inputValue = this.config.editValue.link;
            }
            this.changeValueSet();
        }
    }

    changeValueSet(isFromUser: boolean = false) {
        const combineValue = { 'selectedItem': this.selectedItem, 'inputValue': this.inputValue };
        if (this.config.controlID.indexOf(ControlId.Email) > -1) {
            combineValue['isPrimary'] = this.isPrimary;
        }
        const value = new ContactTemplateControlValue(combineValue, this.config.componentType,
            this.config, isFromUser);
        this._store.dispatch(
            new ChangeContactTemplateValueSet(
                value,
                'prefix',
                this.config.prefixId
            )
        );
    }

    private processPrimaryEmail() {
        if (this.isPrimary) {
            const index = this._contactEmailGroupIds.findIndex(item => item === this.config.controlID);
            let primaryId = '';
            if (index < this._contactEmailGroupIds.length - 1 && this._contactEmailGroupIds.length !== 1) {
                primaryId = this._contactEmailGroupIds[index + 1];
            } else {
                primaryId = ControlId.Email;
            }
            this._contactTemplateService.actionSubject$.next({
                type: EmailAction.SetPrimary,
                payload: {
                    isPrimary: true,
                    id: primaryId
                }
            });
        }
        if (this._contactEmailGroupIds.length > 0) {
            this._contactViewModel.decrement(this.config.controlID, this.config.prefixId);
        }
    }
}
